namespace $ {

	export class $shm_wordstat_task_file extends $mol_object2 {

		task_id() { return '' }
		version() { return '' }
		uri() { return '' }
		token() { return '' }

		opfs_name() {
			const safe = ( value: string )=> value.replaceAll( /[^a-zA-Z0-9_-]/g, '_' )
			return `hitalama_wordstat_${ safe( this.task_id() ) }_${ safe( this.version() ) }.duckdb`
		}

		uri_fetch() {
			return this.uri()
		}

		@ $mol_mem
		buffer() {
			const uri = this.uri_fetch()
			const version = this.version()
			if( !uri || !version ) return null

			const name = this.opfs_name()
			const local = $mol_wire_sync( this ).buffer_local_async( name )
			if( local ) return local

			return $mol_wire_sync( this ).buffer_remote_async(
				name,
				uri,
				this.token(),
				this.task_id(),
			)
		}

		async buffer_local_async( name: string ) {
			const storage = $mol_dom_context.navigator?.storage
			if( !storage?.getDirectory ) throw new Error( 'OPFS is not supported in this browser' )
			const root = await storage.getDirectory()

			try {
				const handle = await root.getFileHandle( name )
				const file = await handle.getFile()
				const buffer = await file.arrayBuffer()
				if( this.valid( buffer ) ) return buffer
				await root.removeEntry( name )
			} catch( _ ) {}

			return null
		}

		async buffer_remote_async( name: string, uri: string, token: string, task_id: string ) {
			const storage = $mol_dom_context.navigator?.storage
			if( !storage?.getDirectory ) throw new Error( 'OPFS is not supported in this browser' )
			const root = await storage.getDirectory()

			const response = await fetch( uri, {
				cache: 'no-store',
				headers: token ? { Authorization: token.startsWith( 'Bearer ' ) ? token : `Bearer ${ token }` } : {},
			} )
			if( !response.ok ) throw new Error( `Не удалось скачать данные Wordstat: ${ response.statusText }` )
			const buffer = await response.arrayBuffer()
			if( !this.valid( buffer ) ) throw new Error( 'Получен некорректный DuckDB-файл Wordstat' )

			const handle = await root.getFileHandle( name, { create: true } )
			const writable = await handle.createWritable()
			try {
				await writable.write( buffer )
			} finally {
				await writable.close()
			}
			await this.cleanup_old( root, name, task_id )
			this.$.$shm_ba_file_store.changed( this.$.$shm_ba_file_store.wordstat_prefix() )
			return buffer
		}

		valid( buffer: ArrayBuffer ) {
			if( buffer.byteLength < 16 ) return false
			const text = new TextDecoder().decode( new Uint8Array( buffer, 0, Math.min( 128, buffer.byteLength ) ) )
			return text.includes( 'DUCK' )
		}

		async cleanup_old( root: FileSystemDirectoryHandle, keep: string, task_id: string ) {
			const prefix = `hitalama_wordstat_${ task_id.replaceAll( /[^a-zA-Z0-9_-]/g, '_' ) }_`
			for await( const name of ( root as any ).keys() ) {
				if( name !== keep && String( name ).startsWith( prefix ) ) {
					await root.removeEntry( String( name ) ).catch( ()=> null )
				}
			}
		}

	}

}
